var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonButtom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.082 19.25V17.4167C21.0814 16.6043 20.811 15.815 20.3133 15.173C19.8155 14.5309 19.1187 14.0723 18.332 13.8692",
    stroke: "#FDFBFF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5846 19.25V17.4167C15.5846 16.4442 15.1983 15.5116 14.5107 14.8239C13.8231 14.1363 12.8904 13.75 11.918 13.75H4.58464C3.61217 13.75 2.67954 14.1363 1.99191 14.8239C1.30428 15.5116 0.917969 16.4442 0.917969 17.4167V19.25",
    stroke: "#FDFBFF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 2.86916C15.4567 3.07111 16.1558 3.52981 16.655 4.17295C17.1542 4.81609 17.4252 5.60709 17.4252 6.42125C17.4252 7.2354 17.1542 8.0264 16.655 8.66955C16.1558 9.31269 15.4567 9.77139 14.668 9.97333",
    stroke: "#FDFBFF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2487 10.0833C10.2737 10.0833 11.9154 8.44171 11.9154 6.41667C11.9154 4.39162 10.2737 2.75 8.2487 2.75C6.22365 2.75 4.58203 4.39162 4.58203 6.41667C4.58203 8.44171 6.22365 10.0833 8.2487 10.0833Z",
    stroke: "#FDFBFF",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonButtom);
export default __webpack_public_path__ + "static/media/personButtom.18d2dfc29ba26bddf815da8e4ff45b80.svg";
export { ForwardRef as ReactComponent };